import { useWatch } from 'react-hook-form';
import styled from 'styled-components';

import { createInterpolatedTranslationKey, Translate } from '@dreryk/react-common';

import { protectFeature } from '~libs.shared.system';

import { visitDetailsTranslationKeys } from '../../../../translations';
import { VisitFormController } from '../../visitForm.types';

import { DiagnosisTableBean } from './DiagnosesFormTab.types';

type DiagnosesFormTabLabelProps = {
   readonly control: VisitFormController['control'];
};

const StyledRequireSign = styled.span`
   color: ${(props) => props.theme.error};
`;

StyledRequireSign.displayName = 'StyledRequireSign';

export const DiagnosesFormTabLabel = (props: DiagnosesFormTabLabelProps): JSX.Element => {
   const creatingMedicalDocumentsAvailable = protectFeature('creatingMedicalDocuments');

   const { length: count } = useWatch<DiagnosisTableBean[]>({
      name: 'diagnoses.value',
      control: props.control,
      defaultValue: [],
   });

   return (
      <>
         <span>
            <Translate>{visitDetailsTranslationKeys.diagnoses.diagnosis}</Translate>
            {creatingMedicalDocumentsAvailable ? <StyledRequireSign>{'*'}</StyledRequireSign> : null}
            <Translate>
               {createInterpolatedTranslationKey(visitDetailsTranslationKeys.diagnoses.diagnosisCounter, {
                  count: count,
               })}
            </Translate>
         </span>
      </>
   );
};
